import { styled } from "styled-components";
const CalendarFooter = styled("div")({
  alignItems: "center",
  borderTop: "1px solid rgba(0, 0, 0, 0.09)",
  display: "flex",
  justifyContent: "center",
  padding: 8
});
export {
  CalendarFooter
};
